import { NgModule, inject } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons';
import { faMinusSquare } from '@fortawesome/free-solid-svg-icons';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { faRedo } from '@fortawesome/free-solid-svg-icons';
import { faHourglassHalf } from '@fortawesome/free-solid-svg-icons';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { faList } from '@fortawesome/free-solid-svg-icons';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { faHospital } from '@fortawesome/free-solid-svg-icons';
import { faFax } from '@fortawesome/free-solid-svg-icons';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import { faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { faFileMedical } from '@fortawesome/free-solid-svg-icons';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { faUndo } from '@fortawesome/free-solid-svg-icons';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { faStopCircle } from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { faServer } from '@fortawesome/free-solid-svg-icons';

@NgModule({
  providers: [
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class SharedModule {
  constructor() {
    const library = inject(FaIconLibrary);

    library.addIcons(faPlusSquare);
    library.addIcons(faPlusCircle);
    library.addIcons(faMinusSquare);
    library.addIcons(faCircleNotch);
    library.addIcons(faCheck);
    library.addIcons(faCog);
    library.addIcons(faCalendar);
    library.addIcons(faTimes);
    library.addIcons(faSearch);
    library.addIcons(faList);
    library.addIcons(faFileAlt);
    library.addIcons(faHospital);
    library.addIcons(faFax);
    library.addIcons(faInfoCircle);
    library.addIcons(faCloudUploadAlt);
    library.addIcons(faCloudDownloadAlt);
    library.addIcons(faAngleDoubleRight);
    library.addIcons(faExclamationCircle);
    library.addIcons(faExclamationTriangle);
    library.addIcons(faExternalLinkAlt);
    library.addIcons(faFileMedical);
    library.addIcons(faHourglassHalf);
    library.addIcons(faTimesCircle);
    library.addIcons(faRedo);
    library.addIcons(faCheckCircle);
    library.addIcons(faUndo);
    library.addIcons(faPen);
    library.addIcons(faTrash);
    library.addIcons(faStopCircle);
    library.addIcons(faCopy);
    library.addIcons(faFileSignature);
    library.addIcons(faServer);
  }
}
